import {send} from 'ajax';
import {runPayment} from 'run_payment';
import {print_browsers} from 'browser';
import {is_safari} from 'browser';
const braintree = require('braintree-web');
const dropin = require('braintree-web-drop-in');

export async function createDropIn(){
  try{
    console.log('run createDropIn');
    var ab_queryString = window.location.search;
    var ab_urlParams = new URLSearchParams(ab_queryString);
    var ab_ = 'a';
    var is_signup = window.location.pathname.includes('signup') || document.getElementById('homepage');
    print_browsers();
    console.log('is_safari is: ' + is_safari());
    if (document.getElementById('dropin-container')){
      document.getElementById('dropin-container').innerHTML = '';
    }

    const token = await send("GET", "/santa/get_bt_token");
    if (!token) {
      Turbolinks.visit('/santa/text'); // Maybe different redirect here
    }

    // braintree payment types ab test
    //const ab_test = await send('GET', '/santa/check_ab_testing?' + ab_urlParams);
    //ab_ = ab_test.result;

    // Use this bt_params if you want to remove apple pay
    var bt_params_a = 
      {authorization: token.bt_token,
      container: '#dropin-container',
        paypal: {
          flow: 'vault',
          buttonStyle: {
            size: 'small',
            tagline: 'false'
          }, 
        },
        dataCollector: {
           kount: true // Required if Kount fraud data collection is enabled
        } };

    // Use this bt_params if you want to include apple pay
    var bt_params_b = 
      {authorization: token.bt_token,
      container: '#dropin-container',
      applePay: {
        displayName: 'TextsFromSanta',
        flow: 'vault',
        paymentRequest: {
          total: {
            label: 'TextsFromSanta',
            amount: document.getElementById('fc_p').innerHTML 
          },
        requiredBillingContactFields: ["postalAddress"]
        }},
        paypal: {
          buttonStyle: {
            size: 'small',
            tagline: 'false'
          }, 
          flow: 'vault'
        },
        dataCollector: {
           kount: true // Required if Kount fraud data collection is enabled
        },
         paymentOptionPriority: ['applePay', 'card', 'paypal']
       };
    //console.log('checking ab PARAMS JEN: ', ab_);
    
    //  removing apple pay  100%
    /*if (ab_ == 'b') {
      var bt_params = bt_params_b;
    }
    else {
      var bt_params = bt_params_a;
    }*/
    // Wallets on: Apple Pay (no billing address, so it's one tap) and, once a
    // Google merchant ID is configured, Google Pay. Wallet buttons come first.
    var bt_params = {
      authorization: token.bt_token,
      container: '#dropin-container',
      applePay: {
        displayName: 'TextsFromSanta',
        paymentRequest: {
          total: { label: 'TextsFromSanta', amount: document.getElementById('fc_p').innerHTML }
        }
      },
      paypal: bt_params_a.paypal,
      dataCollector: { kount: true },
      paymentOptionPriority: ['applePay', 'googlePay', 'card', 'paypal']
    };
    var gpay_merchant = document.getElementById('google_pay_merchant_id');
    if (gpay_merchant && gpay_merchant.innerHTML.trim().length > 0) {
      bt_params.googlePay = {
        googlePayVersion: 2,
        merchantId: gpay_merchant.innerHTML.trim(),
        transactionInfo: { totalPriceStatus: 'FINAL', totalPrice: document.getElementById('fc_p').innerHTML, currencyCode: 'USD' }
      };
    }

    var bt_button = document.getElementById('submit-payment_button');
    var terms = document.getElementById('terms');
    //var t = 'terms first ab';
    var t = 'terms first';
    if (terms) {
      terms.classList = t;
    }
    dropin.create( bt_params,
     function (createErr, instance) {
      if (createErr) {
        console.error(createErr);
        if (bt_button){
          bt_button.classList = '';
          if (terms) {
            terms.classList = t;
          }
        }

        return;
      }
      window.tfsDropin = instance;
      var cmb = document.querySelector('[data-braintree-id="toggle"]');
      var cont = document.querySelector('[data-braintree-id="sheet-container"]');
      cont.prepend(cmb);
      var change_method_buttons = document.getElementsByClassName('braintree-large-button');
      if (change_method_buttons) {
        var change_method_button = change_method_buttons[0];
        if (change_method_button){
          change_method_button.addEventListener('click', function() { 
            bt_button.classList = '';
            if (terms) {
              terms.classList = t;
            }
          });
        } 
      }

      var choose_payment = document.getElementById('choose-payment');
      instance.on('paymentOptionSelected', function() {
        if (choose_payment) {
          choose_payment.classList.add('hidden');
        }
      });

      bt_button.addEventListener('click',function(){
       bt_button.classList = 'hidden';
       if (change_method_button){ 
         change_method_button.classList.add('hidden');
       }
    
       if (terms) {
         terms.classList =  t + ' no_payment_button';
       }
       instance.requestPaymentMethod( (requestPaymentMethodErr, payload) => {
         if (requestPaymentMethodErr) {
           console.error(requestPaymentMethodErr);
           // Nothing chosen yet from "Choose a way to pay": Drop-in shows no message
           // for this, so Checkout would look broken.
           if (choose_payment && document.querySelector('.braintree-show-options')) {
             choose_payment.classList.remove('hidden');
           }
           if (is_signup) {
             document.getElementById('processing').classList.add('hidden');
           } 
           if (bt_button){
             bt_button.classList = '';
             if (terms) {
               terms.classList = t;
             }
           }
           return;
         }
         runPayment(payload);
        });
      });



    });
  }
  catch (err) {
    console.log('Braintree error: ' + err);
    if (is_signup) {
      document.getElementById('processing').classList.add('hidden');
    } 
    if (bt_button){
      bt_button.classList = '';
      if (terms) {
        terms.classList = t;
      }
    }
  }
}



// Keep the wallet payment sheets showing the current price (e.g. after a promo code).
export function updateWalletAmount(amount) {
  var instance = window.tfsDropin;
  if (!instance) { return; }
  try {
    instance.updateConfiguration('applePay', 'paymentRequest', { total: { label: 'TextsFromSanta', amount: String(amount) } });
  } catch (err) { console.log('apple pay amount update: ' + err); }
  try {
    instance.updateConfiguration('googlePay', 'transactionInfo', { totalPriceStatus: 'FINAL', totalPrice: String(amount), currencyCode: 'USD' });
  } catch (err) { console.log('google pay amount update: ' + err); }
}
